import { createContext, useContext } from 'react';
import { OptionsCalculatorDataContextType } from './OptionsCalculatorContextProvider';

export const OptionsCalculatorDataContext =
  createContext<OptionsCalculatorDataContextType | null>(null);

// Custom hooks for consuming context
export const useOptionsCalculatorData =
  (): OptionsCalculatorDataContextType => {
    const context = useContext(OptionsCalculatorDataContext);
    if (context == null) {
      throw new Error(
        'useOptionsCalculatorData must be used within OptionsCalculatorProvider',
      );
    }
    return context;
  };
